import React, { FC, memo } from 'react'

import { Button } from '@Components/Button'
import {
  useDefaultCheckoutResponse,
} from '@Domains/CheckoutV2/Features/CheckoutSteps/Steps/CheckoutPaymentStep/Components/ProviderComponents/Default/hooks/useDefaultCheckoutResponse'
import { CheckoutPaymentComponentProps } from '@Domains/CheckoutV2/Features/CheckoutSteps/Steps/CheckoutPaymentStep/Hooks/usePaymentComponentFactory'
import { useTranslation } from '@Globals/Translations'
import { CheckoutV2FinalizeCartResult } from '@Pages/onestepcheckout'

import styles from './EpayViaBill.module.scss'

export const EpayViaBillButton: FC<CheckoutPaymentComponentProps> = memo(({ option, submitPayment }) => {
  const { handlePaymentSubmitResponse } = useDefaultCheckoutResponse()
  const { t } = useTranslation()
  return (
    <div className={styles.epayViaBillWrapper}>
      <Button
        className={styles.redirectButton}
        onClick={() => submitPayment(
          { type: 'viabill' },
          (response: CheckoutV2FinalizeCartResult) => handlePaymentSubmitResponse(option.type, response),
        )}
      >
        {t('checkout:COF_GO_TO_SECURE_PAYMENT')}
      </Button>
    </div>
  )
})
